import { asyncAction, asyncReducer, asyncSelector } from '../utils'
import { JobsServiceProvider } from '../../api/jobs'

const JobsService = JobsServiceProvider()
const nameJob = 'getJobs'

export default () => (asyncAction(
  nameJob,
  JobsService.getJobs
))

export const reducer = asyncReducer(nameJob)
export const selector = asyncSelector(nameJob)



// WEBPACK FOOTER //
// ./src/store/jobs/getJobs.js